export const events = {
  // FIXME: Fix events names so they match the ones in Amplitude
  viewedProductUpsellComponent: 'View product upsell component',
  clickProductUpsellComponent: 'Click product upsell component',
  dismissedProductUpsellComponent: 'Dismiss product upsell component',
  clickedLearnMoreProductUpsellComponent: 'Clicked learn more product upsell component',
  clickedLearnMoreSelfUpsellSegment: 'Clicked learn more self upsell segment',
  openProductModal: 'Open product upsellmodal',
  sendEmail: 'Send email',
}
